import { gql } from 'graphql-request'
import {
  SELF_PAYMENT_OBLIGATIONS_DETAILS,
  SETTLEMENT_OBLIGATIONS_DETAILS,
  TRANSLATION_VALUES
} from './fragments'

/** GraphQL query to get version info. */
export const GET_API_VERSION = gql`
  query {
    versionInfo {
      version
    }
  }
`

/** GraphQL query to get user info. */
export const GET_USER_INFO = gql`
  query {
    userInfo {
      yhteystiedot {
        osoitteet {
          maaKoodi
          maa
          virheellinen
          id
          poisto
          postinumero
          postitoimipaikka
          ensisijainen
          katuosoite
          tyyppi
          voimaantulopvm
          paattymispvm
        }
        sahkopostit {
          sahkopostiosoite
          id
          ensisijainen
          tyyppi
        }
        puhelinnumerot {
          id
          ensisijainen
          poisto
          puhelinnumero
          tyyppi
        }
      }
      luvat {
        valinta
        id
        kohde
        kohde_en
        kohde_sv
        kohdeKoodi
        kohdeKuvaus
      }
      asiointikieli
      jasennumero
      nimi {
        kutsumanimi
        sukunimi
        etunimet
      }
      kansalaisuus {
        kansalaisuusKoodi
        kansalaisuus
      }
      aidinkieli {
        aidinkieliKoodi
        aidinkieli
      }
      viimeisinKirjautuminen
    }
    membershipSummaryInfo {
      jasennumero
      jasenyys {
        ammattiosasto
        ammattiosastoTunnus
      }
    }
    employmentSummaryInfo {
      tyosuhteet {
        alkupvm
        loppupvm
        taNimi
      }
    }
  }
`
/** GraphQL query to get member emails and sms. */
export const GET_EMAILS_AND_SMS = gql`
  query {
    memberEmailsAndSms {
      lahetysPvm
      viestinNimi
      viestinSisalto
    }
  }
`

/** GraphQL query to get member letters. */
export const GET_LETTERS = gql`
  query {
    memberLetters {
      lahetysPvm
      viestinNimi
      viestinSisalto
    }
  }
`

/** GraphQL query to get membership info. */
export const GET_MEMBERSHIPS = gql`
  query {
    membershipInfo {
      jasennumero
      jasenyys {
        jasenlaji
        ammattiosasto
        ammattiosastoTunnus
        liittymispvm
      }
    }
    membershipMagazines {
      lehdet {
        lehti
        alkupvm
        loppupvm
      }
    }
    membershipCard {
      jasenkortti
      jasenkortin_nimi
      jasenkortin_tyyppi
      jasenkortin_tyyppi_nimi
      jasenkortin_toimituspvm
      kortin_tilaus
    }
  }
`

/** GraphQL query to get employment info. */
export const GET_EMPLOYMENTS = gql`
  query {
    employments {
      tyosuhteet {
        alkupvm
        loppupvm
        paatoiminen
        taNimi
        tpNimi
        tunniste
        workPlaceOptions {
          display
          value
        }
      }
      ammattiNimike
    }
    employmentObligations {
      selfPaymentObligations {
        ...SelfPaymentObligationsDetails
      }
    }
  }
  ${SELF_PAYMENT_OBLIGATIONS_DETAILS}
`

/** GraphQL query to get membership fee info. */
export const GET_MEMBERSHIP_FEES = gql`
  query {
    accrualBasesLastYear {
      tyyppi
      prosentti
      summa
      summaMaksukatto
      maksujaksonAlkupvm
      maksujaksonLoppupvm
    }
    accrualBasesThisYear {
      tyyppi
      prosentti
      summa
      summaMaksukatto
      maksujaksonAlkupvm
      maksujaksonLoppupvm
    }
    membershipFeeObligations {
      paymentExemptions {
        tunniste
        aloituspvm
        lopetuspvm
        vapautuslajiKoodi
        vapautuslaji
        vapautussyyKoodi
        vapautussyy
      }
      selfPaymentObligations {
        ...SelfPaymentObligationsDetails
      }
      settlementObligations {
        ...SettlementObligationsDetails
      }
    }
    paidMembershipFees {
      maksujaksoAlkupvm
      maksujaksoLoppupvm
      summa
      maksajanNimi
      tapahtumatyyppi
      verovuosi
      viitenumero
      maksajanMaksupvm
      peruttu
    }
    refenceNumbers {
      alkupvm
      erapaiva
      loppupvm
      viitenumero
      pankkiviivakoodi
    }
    bankAccounts {
      konttori
      iban
    }
  }
  ${SELF_PAYMENT_OBLIGATIONS_DETAILS}
  ${SETTLEMENT_OBLIGATIONS_DETAILS}
`
/** GraphQL query to get translations. */
export const GET_LOCALIZED_OPTIONS = gql`
  query {
    countries {
      ...TranslationValues
    }
    emailTypes {
      ...TranslationValues
    }
    exemptionReasons {
      ...TranslationValues
    }
    languages {
      ...TranslationValues
    }
    postalCodes {
      ...TranslationValues
    }
  }
  ${TRANSLATION_VALUES}
`
/** GraphQL query to get assignment info. */
export const GET_ASSIGNMENTS = gql`
  query {
    assignments {
      jarjestotehtavat {
        aloituspvm
        jarjestoyksikonNimi
        kaudenLopetuspvm
        lopetuspvm
        tehtava
      }
      luottamustehtavat {
        aloituspvm
        kaudenLopetuspvm
        lopetuspvm
        tehtava
        taNimi
        tpNimi
      }
    }
  }
`

/** GraphQL query to get news. */
export const GET_API_NEWS = gql`
  query {
    news {
      id
      type
      translations {
        content
        endDate
        header
        lang
        startDate
      }
    }
  }
`
